export function userInputGender() {
    return {
        restrict: 'E',
        scope: {
            data: '=',
            displayType: '@?',
            customGenders: '=?',
        },
        templateUrl: Evisors.config.cdnRootWhitelabel + 'asset/partials/registration/directives/userInputs/userInputGender.html',
        controller: [
            '$scope', function($scope) {
                $scope.showTip = false;
                $scope.hideModal = function() {
                    $scope.showTip = false;
                };
            },
        ],
    };
}
